import type { Venue } from '../../types/venue';

export const ystadSaltsjobad: Venue = {
  id: 'ystad-saltsjobad',
  name: 'Ystad Saltsjöbad',
  description: {
    en: `<p>Leave the four walls of the office and recharge with new energy and inspiration! Why not have your monthly meeting on the terrace or end your strategy day by stepping into Lido Club & Spa? Come and discover what a difference a change of environment can make!</p>`,
    
    sv: `<p>Lämna kontorets fyra väggar och fyll på med såväl ny energi som inspiration! Varför inte ta månadsmötet ute på terrassen eller avrunda strategidagen med att få kliva in på Lido Club & Spa? Kom och upptäck vilken skillnad ett miljöbyte kan göra!</p>`,
    
    no: `<p>Forlat kontorets fire vegger og lad opp med ny energi og inspirasjon! Hvorfor ikke ha månedsmøtet på terrassen eller avslutte strategidagen med å besøke Lido Club & Spa? Kom og opplev hvilken forskjell et miljøskifte kan gjøre!</p>`,
    
    da: `<p>Forlad kontorets fire vægge og genoplad med ny energi og inspiration! Hvorfor ikke afholde månedsmødet på terrassen eller afslutte strategidagen med at træde ind i Lido Club & Spa? Kom og opdag, hvilken forskel et miljøskifte kan gøre!</p>`
  },
  image: '/assets/images/ysb.jpg',
  country: 'se',
  region: 'skane',
  city: 'Ystad',
  address: 'Saltsjöbadsvägen 15, 271 39 Ystad, Sweden',
  coordinates: {
    lat: 55.4292,
    lng: 13.8263
  },
  capacity: {
    min: 10,
    max: 300
  },
  rating: 4.8,
  reviews: Array.from({ length: 240 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.8,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'pool', 'spa', 'gym'],
  images: [
    '/assets/images/ysb.jpg',
    'https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&q=80&w=2000'
  ],
  priceRange: {
    min: 2500,
    max: 45000
  },
  recommended: false,
  factbox: {
    rooms: 139,
    conferenceRooms: 7,
    meetingCapacity: 300,
    features: [
      '4 restaurants',
      '139 double rooms',
      '7 conference rooms',
      '5 group rooms',
      'Capacity for 300 participants',
      '11 pools',
      'Just 18 steps from the sea',
      'Lido Club & Spa facilities',
      'Fully equipped gym',
      'Free WiFi throughout the property',
      '1 hour from Malmö',
      'Seaside location with beautiful views',
      'Terrace meeting spaces available',
      'Variety of room setups for different meeting types',
      'Modern conference technology',
      'Full catering services',
      'Wellness and relaxation options after meetings'
    ]
  }
}; 